import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { CASE_STUDIES } from "../../data/site";

export default function CaseStudies() {
  return (
    <section
      id="work"
      data-testid="casestudies-section"
      className="py-24 md:py-36 bg-white border-t border-black/10"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 mb-16">
          <div className="lg:col-span-5">
            <div className="flex items-center gap-3 mb-6">
              <span className="w-6 h-px bg-[#FF331F]" />
              <span className="font-mono-ibm text-[11px] tracking-[0.2em] uppercase text-[#FF331F]">
                Selected work / 04
              </span>
            </div>
            <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl tracking-tighter leading-[1.05] font-medium">
              Evidence over adjectives.
            </h2>
          </div>
          <div className="lg:col-span-6 lg:col-start-7 lg:pt-4">
            <p className="text-lg text-[#404040]">
              A small sample of the systems we’ve shipped. Engagements range
              from 8-week analysis sprints to multi-year platform builds.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-12 lg:auto-rows-[240px] gap-4 md:gap-6">
          {CASE_STUDIES.map((c, i) => (
            <motion.article
              key={c.title}
              data-testid={`case-card-${i}`}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.6, delay: i * 0.08 }}
              className={`relative overflow-hidden border border-black/10 group bg-[#2A2A2A] text-white ${c.span} col-span-1`}
            >
              <img
                src={c.image}
                alt={c.title}
                className="absolute inset-0 w-full h-full object-cover opacity-90 group-hover:opacity-100 group-hover:scale-105 transition-all duration-700"
              />
              <div
                className="absolute inset-0"
                style={{
                  background: `linear-gradient(to top, ${c.accent}E6 0%, ${c.accent}66 35%, transparent 80%)`,
                }}
              />
              <div className="relative h-full flex flex-col justify-between p-6 md:p-8 min-h-[260px]">
                <div className="flex items-center justify-between">
                  <span
                    className="font-mono-ibm text-[11px] uppercase tracking-widest text-white bg-white/20 px-2 py-1 backdrop-blur-sm"
                  >
                    {c.tag}
                  </span>
                  <ArrowUpRight
                    size={22}
                    className="opacity-80 group-hover:rotate-45 transition-transform duration-500"
                  />
                </div>
                <div>
                  <div className="font-display text-2xl md:text-3xl tracking-tight leading-tight">
                    {c.title}
                  </div>
                  <p className="mt-3 text-sm text-white/80 max-w-xl leading-relaxed">
                    {c.summary}
                  </p>
                  <div
                    className="mt-5 font-mono-ibm text-xs tracking-widest text-white"
                  >
                    {c.metric}
                  </div>
                </div>
              </div>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
}
